module.exports = __webpack_public_path__ + "static/media/docs.63cfd90e.md";


//////////////////
// WEBPACK FOOTER
// ./src/components/CXs/content/docs.md
// module id = 1253
// module chunks = 0